var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UniqueUserId } from '@xylabs/pixel';
import { delay } from '@xyo-network/sdk-xyo-js';
import { Cart } from '../useCart';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import TestData from './TestData';
import TiktokEvents from './Tiktok';
class TiktokEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new TiktokEvents();
    }
    emailCollected(_fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    accountCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    shareCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    buyticketsCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    installCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    funnelCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    offerRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    feedbackScoreCollected() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    feedbackSourceCollected() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    goodFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    badFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    addressInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addBilling().send(this.buildCustomProperties());
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addToCart().send(this.buildCustomProperties());
        });
    }
    purchaseCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            const cart = Cart.get();
            yield this.events.purchase().send(this.buildCustomProperties({
                currency: 'USD',
                value: cart.getValue(),
            }));
        });
    }
    userClick(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.clickButton().send(fields);
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.startCheckout().send(this.buildCustomProperties());
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    funnelStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.purchaseCompleted();
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    testStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0);
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.viewContent().send(this.buildCustomProperties(fields));
        });
    }
    buildCustomProperties(data) {
        const cart = Cart.get();
        const coinId = new UniqueUserId().id;
        const testData = new TestData().data;
        return Object.assign(Object.assign({}, data), { coinId, itemSet: cart.getItemSet(), testData });
    }
}
export default TiktokEventHandler;
//# sourceMappingURL=TiktokEventHandler.js.map